import axios from 'axios'
import type { ErrorResponse } from '@/types/common'

export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (!axios.isAxiosError<ErrorResponse>(err)) {
    return fallback
  }

  const status = err.response?.status
  const message = err.response?.data?.message

  if (status === 401) {
    return 'Your session expired. Please sign in again.'
  }

  if (message) {
    return message
  }

  return fallback
}
